var DocumentRequestModule = (function () {
    function DocumentRequestModule() {
    }
    return DocumentRequestModule;
}());
export { DocumentRequestModule };



// WEBPACK FOOTER //
// /opt/app/src/app/features/document-request/document-request.module.ts.pre-build-optimizer.js